import customersReducer from "./customersSlice";
import customerReducer from "./customersSlice";

const customers = {
  customers: customersReducer,
  customer: customerReducer,
};

export default customers;
